import { render, staticRenderFns } from "./Architecture.vue?vue&type=template&id=7b252f03&scoped=true"
import script from "./Architecture.vue?vue&type=script&lang=js"
export * from "./Architecture.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b252f03",
  null
  
)

export default component.exports